import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const NorthCarolina = () => {
  return (
    <StatePropertyTaxPage
      stateName="North Carolina"
      processDescription="Property owners may appeal their assessment by filing with the local board of commissioners or board of equalization and review during the specified appeal period. Appeals should include evidence supporting the property owner's claimed value."
      noticeOfValueMailed="May"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in May following the county's revaluation or annual assessment review."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="North Carolina assesses property as of January 1 each year, with counties conducting revaluations every 4-8 years. This assessment date ensures consistent timing across all counties."
      deadlineExplanation="Property owners typically have until the first Monday in September to file appeals, though the exact deadline may vary by county. Appeals must be filed during the county's designated appeal period."
    />
  );
};

export default NorthCarolina;